module.exports = __webpack_public_path__ + "body1-bg.png?9622bb679f67d5124f4274e4a0885897";


//////////////////
// WEBPACK FOOTER
// ./src/assets/body1-bg.png
// module id = 158
// module chunks = 0